import { CircuitFormDataWithTranslations } from '@/i18n/translation-type-utils';
import { CircuitDetailsDescription } from '@/pages/distributor/circuits/CircuitDetailsPage';
import { CircuitBookingPreviewState } from '@/types/circuits/CircuitBookingPreview';
import { SupportedLocale } from '@/types/supported-locale.type';
import { Control, useWatch } from 'react-hook-form';

interface CircuitFormDetailsViewProps {
  control: Control<CircuitFormDataWithTranslations>;
  circuitId: string;
  circuitCurrency: string;
  currStep: number;
  setCurrStep: React.Dispatch<React.SetStateAction<number>>;
  selectedArrivalDate: Date;
  setSelectedArrivalDate: React.Dispatch<React.SetStateAction<Date>>;
  language: SupportedLocale;
  publishCircuit?: () => void;
  errorsLength?: number;
  isValid?: boolean;
  bookingPreview?: CircuitBookingPreviewState;
}

const CircuitFormDetailsView = ({
  control,
  circuitId,
  circuitCurrency,
  currStep,
  setCurrStep,
  selectedArrivalDate,
  setSelectedArrivalDate,
  publishCircuit,
  errorsLength,
  isValid,
  language,
  bookingPreview,
}: CircuitFormDetailsViewProps) => {
  const parsedCircuit = useWatch({
    control,
  }) as CircuitFormDataWithTranslations;

  return (
    <CircuitDetailsDescription
      circuitId={circuitId}
      parsedCircuit={parsedCircuit}
      circuitCurrency={circuitCurrency}
      onSelectOptionsButtonClick={() => {
        setCurrStep(4);
        window.scrollTo(0, 0);
      }}
      selectedArrivalDate={selectedArrivalDate}
      setSelectedArrivalDate={setSelectedArrivalDate}
      isDetailsAndOptions={currStep === 4}
      publishCircuit={publishCircuit}
      errorsLength={errorsLength}
      isValid={isValid}
      language={language}
      canCreateEditableCircuitFromCircuit={false}
      bookingPreview={bookingPreview}
    />
  );
};

export default CircuitFormDetailsView;
